import { Router, ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { Observable } from 'rxjs';
import { SystemUserEulaService } from '../shared/services/system-user-eula.service';

@Injectable()
export class EulaGuardService {
  constructor(
    public auth: AuthService,
    public systemUserEulaService: SystemUserEulaService,
    public route: ActivatedRoute,
    public router: Router
  ) {}

  canActivate(): boolean | Observable<boolean> | Promise<boolean> {
    let obs = this.systemUserEulaService.hasLoggedInSystemUserAcceptedLatestEula;
    obs.subscribe((res) => {
      if (res === false) {
        this.systemUserEulaService.setAttemptedRoute(location.pathname);
        this.router.navigateByUrl('/home');
      }
    });
    return true;
  }

  canActivateChild(): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate();
  }

  canLoad(): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate();
  }
}
